<template>
  <div>
    <h2>Formulário Dinâmico</h2>

    <form @submit="onSubmit">
      <SGPFormSelectComponent
        name="formulario"
        v-model="formularioSelecionado"
        :listaDeOptions="listaDeFormularios"
        optionKey="id"
        optionLabel="titulo"
        placeholder="Lista de formulários"
      />
    </form>

    <br><br>

    <RenderizaFormularioComponent v-if="formularioSelecionado" :key="formularioSelecionado" :formulario_id="formularioSelecionado" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import RenderizaFormularioComponent from '../components/RenderizaFormularioComponent.vue'
export default {
  components: { RenderizaFormularioComponent },
  name: 'FormularioPage',

  data () {
    return {
      formularioSelecionado: 1,
      formularios: [
        {
          id: 1,
          label: 'Avançar'
        },
        {
          id: 2,
          label: 'Devolver'
        },
        {
          id: 3,
          label: 'Pendenciar'
        }
      ]
    }
  },

  created () {
    this.listarFormularios()
  },

  computed: {
    ...mapGetters('formularios', ['listaDeFormularios'])
  },

  methods: {
    ...mapActions('formularios', ['listarFormularios']),

    onSubmit () {
      console.log(this.formularioSelecionado)
    }
  },

  watch: {
    formularioSelecionado (val) {
      console.log(val)
    }
  }
}
</script>